import { render, staticRenderFns } from "./AppraisalCommittee.vue?vue&type=template&id=4db86bec&scoped=true"
import script from "./AppraisalCommittee.vue?vue&type=script&lang=js"
export * from "./AppraisalCommittee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db86bec",
  null
  
)

export default component.exports